import { useMediaQuery } from "react-responsive"

const deviceSize = {
  mobileL: 425,
  mobile: 828,
  tablet: 1240,
  laptop: 1240,
}

export const device = {
  mobileL: `screen and (max-width: ${deviceSize.mobileL}px)`,
  mobile: `screen and (max-width: ${deviceSize.mobile}px)`,
  tablet: `screen and (max-width: ${deviceSize.tablet}px)`,
  laptop: `screen and (min-width: ${deviceSize.laptop}px)`,
}

export const useBreakpoints = () => {
  const breakpoints = {
    sm: 448,
    md: 690,
    lg: 1024,
    xl: 1280,
  }

  return {
    isSmallScreen: useMediaQuery({ maxWidth: breakpoints.sm }),
    isMediumScreen: useMediaQuery({ 
      minWidth: breakpoints.sm + 1,
      maxWidth: breakpoints.md 
    }),
    isLargeScreen: useMediaQuery({ minWidth: breakpoints.md + 1 })
  }
}
